import React from 'react'

const Ordermanagement = () => {
  return (
    <div>Ordermanagement</div>
  )
}

export default Ordermanagement